import { useAppDispatch, useAppSelector } from "../../app";
import { useCallback } from "react";
import {
  changeActiveEntity,
  changeScrollToEntity,
} from "../../app/store/appSlice";
import { MIN_TABLE_CONTROLS_HEIGHT } from "../../annotationTableControls/constants";
import { setSelectedGroupBlockId } from "../../annotationTableControls/store/AnnotationTableControlsSlice";
import entityWithGroupBlockSelector from "../../configMap/selectors/entityWithGroupBlockSelector";
import useSetGroupBlockTabHeightByLines from "../../annotationTableControls/hooks/useSetTableControlsHeight";
import { shallowEqual } from "react-redux";
import { trackButtonClick } from "../../common/utilities/tracking";
import { setHighlightedEntities } from "../../annotation/store/annotationSlice";
import { HighlightedEntity } from "../../annotation/interfaces/annotation";

const useFindAnnotation = (entityId: string, index: number) => {
  const dispatch = useAppDispatch();

  const entityWithGroupBlock = useAppSelector(
    (state) => entityWithGroupBlockSelector(state, { entityId, index }),
    shallowEqual,
  );

  const { tableControlsHeight } = useAppSelector(
    (state) => state.annotationTableControlsReducer,
    shallowEqual,
  );

  const { setTableControlsHeightByLines } = useSetGroupBlockTabHeightByLines();

  return useCallback(() => {
    if (!entityWithGroupBlock) {
      return;
    }

    const { groupBlock } = entityWithGroupBlock;

    if (groupBlock.multipleGroupBlocks && groupBlock.id) {
      if (tableControlsHeight === MIN_TABLE_CONTROLS_HEIGHT) {
        setTableControlsHeightByLines();
      }

      dispatch(setSelectedGroupBlockId(groupBlock.id));
    }

    // Clear active entity and highlight only the clicked entity for visual feedback
    dispatch(changeActiveEntity(undefined));
    const entitiesToHighlight: HighlightedEntity[] = [
      {
        id: entityId,
        index,
      },
    ];
    dispatch(setHighlightedEntities(entitiesToHighlight));

    dispatch(changeScrollToEntity(entityWithGroupBlock.entity));
    trackButtonClick("annotator-annotation-search");
  }, [
    dispatch,
    entityWithGroupBlock,
    tableControlsHeight,
    setTableControlsHeightByLines,
    index,
    entityId,
  ]);
};

export default useFindAnnotation;
